import OnTreatmentStatus from './OnTreatmentStatus';
import SpecialistDepartment from './SpecialistDepartment';

const Badge = () => {
  return <></>;
};

export default Object.assign(Badge, { OnTreatmentStatus, SpecialistDepartment });
